// components/utils/walletUtils.js
import { ethers } from 'ethers';

const connectWalletAuto = async (setWalletAddress, setIsConnected, setWalletType) => {
  try {
    const accounts = await window.ethereum.request({ method: 'eth_requestAccounts' });
    if (accounts.length > 0) {
      setWalletAddress(accounts[0]);
      setIsConnected(true);

      // ✅ Detect wallet type
      if (window.ethereum.isTrust) {
        setWalletType('trustwallet');
      } else if (window.ethereum.isMetaMask) {
        setWalletType('metamask');
      } else {
        setWalletType('unknown');
      }
    }
  } catch (err) {
    console.error("Auto connect failed:", err.message);
  }
};

const connectTrustWallet = (setWalletAddress, setIsConnected, setWalletType) => {
  if (window.ethereum && window.ethereum.isTrust) {
    connectWalletAuto(setWalletAddress, setIsConnected, setWalletType);
  } else {
    const url = encodeURIComponent("https://vortrex.site");
    window.location.href = `https://link.trustwallet.com/open_url?coin_id=20000714&url=${url}`;
  }
};

export { connectTrustWallet };
